import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CreateInteractionLogCommand, DatasetIntegrationLogDto, DeleteInteractionLogsCommand, IInteractionLogClient, InteractionLogClient, ProjectInteractionLogDto} from "app/ApiClient";
import { LoadingState } from "types";
import { initialInteractionLogsState } from "./InteractionLogsState";
import { RootState } from "@store";

const interactionLogsClient: IInteractionLogClient = new InteractionLogClient(process.env.REACT_APP_API_URL);
const DELETESUCCESSMESSAGE = 'Activity logs reset successfully.';

export const createInteractionLogs = createAsyncThunk(
  "interactionLog/create",
  async (request: CreateInteractionLogCommand, { rejectWithValue }) => {
    try {
      const result = await interactionLogsClient.create(request);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);


export const deleteInteractionLogsForSelectedEmail = createAsyncThunk(
  "interactionLog/delete",
  async (request: DeleteInteractionLogsCommand, { rejectWithValue }) => {
    try {
      const result = await interactionLogsClient.deleteInteractionLogsForSelectedEmail(request);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRecentInteractionLogs = createAsyncThunk(
  "interactionLog/getrecentInteractionLogs",
  async ({ pageSize, limitToDays }: { pageSize: number, limitToDays?: number }, { rejectWithValue }) => {
    try {
      return await interactionLogsClient.recentInteractionLogs(pageSize, limitToDays);
    }
    catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getRecentInteractionsCount = createAsyncThunk(
  "interactionLog/getRecentInteractionsCount",
  async ({  limitToDays }: { limitToDays?: number }, { rejectWithValue }) => {
    try {
      return await interactionLogsClient.recentInteractionCount(limitToDays);
    }
    catch (error) {
      return rejectWithValue(error);
    }
  }
);

const interactionLogsSlice = createSlice({
  name: "interactionLogs",
  initialState: initialInteractionLogsState,
  reducers: {
    resetInteractionLogs: (state) => {
          state.loading = LoadingState.idle;
          state.errorMessage = undefined;
          state.deleteLoading = LoadingState.idle;
          state.deleteSuccessMessage = undefined;
          state.recentInteractionLogsStatus = LoadingState.idle;
        },
  },
  extraReducers: (builder) => {
    // create interaction logs
    builder.addCase(createInteractionLogs.pending, (state) => {
      state.loading = LoadingState.pending;      
      state.errorMessage = undefined;
    });
    builder.addCase(createInteractionLogs.fulfilled, (state) => {
      state.loading = LoadingState.succeed;      
      state.errorMessage = undefined;
    });
    builder.addCase(createInteractionLogs.rejected, (state, { error: { message } }) => {
      state.loading = LoadingState.failed;      
      state.errorMessage = message;
    });
    builder.addCase(deleteInteractionLogsForSelectedEmail.pending, (state) => {
      state.deleteLoading = LoadingState.pending; 
      state.deleteSuccessMessage = undefined;     
      state.errorMessage = undefined;
    });
    builder.addCase(deleteInteractionLogsForSelectedEmail.fulfilled, (state) => {
      state.deleteLoading = LoadingState.succeed;   
      state.deleteSuccessMessage =  DELETESUCCESSMESSAGE;  
      state.errorMessage = undefined;
    });
    builder.addCase(deleteInteractionLogsForSelectedEmail.rejected, (state, { error: { message } }) => {
      state.deleteLoading = LoadingState.failed;    
      state.deleteSuccessMessage = undefined;       
      state.errorMessage = message;
    });
    builder.addCase(getRecentInteractionLogs.pending, (state)=>{
      state.recentInteractionLogsStatus= LoadingState.pending;
    });
    builder.addCase(getRecentInteractionLogs.fulfilled, (state, {payload})=>{
      state.recentInteractionLogs = payload;
      state.recentInteractionLogsStatus = LoadingState.succeed;
    });
    builder.addCase(getRecentInteractionLogs.rejected, (state)=>{
      state.recentInteractionLogsStatus = LoadingState.failed;
    });
    builder.addCase(getRecentInteractionsCount.pending, (state)=>{
      state.recentInteractionsCountStatus= LoadingState.pending;
    });
    builder.addCase(getRecentInteractionsCount.fulfilled, (state, {payload})=>{
      state.recentInteractionsCount = payload;
      state.recentInteractionsCountStatus = LoadingState.succeed;
    });
    builder.addCase(getRecentInteractionsCount.rejected, (state)=>{
      state.recentInteractionsCountStatus = LoadingState.failed;
    })
  },
});
export const { resetInteractionLogs } = interactionLogsSlice.actions;
export default interactionLogsSlice.reducer;

export const hasRecentActivitiesSelector = (state: RootState): boolean => (state.interactionLogs.recentInteractionsCount ?? 0  )> 0;

export const recentActivitiesSelector = ({ interactionLogs}: RootState): [ ProjectInteractionLogDto[]|null, DatasetIntegrationLogDto[]|null] => {
  const { recentInteractionLogs} = interactionLogs
  if( !recentInteractionLogs)
    return [ null, null ];
  const { dataSetInteractions = null , projectInteractions = null} = recentInteractionLogs;
  return [ projectInteractions, dataSetInteractions]
}
